const projects = [
  {
    group: "Web",
    projectName: "Nightlife",
    description: "Redux app with twitter authentication and mongoDB",
    tags: ["Redux", "React", "Express", "MongoDB"],
    progress: 100,
    level: "Advanced",
    imgSrc: "https://i.ibb.co/8P0703L/Screen-Shot-2020-03-16-at-9-17-30-PM.png"
  },
  {
    group: "Web",
    projectName: "Voting App",
    description: "Redux app with twitter authentication, mongodDB and Chart.js",
    tags: ["Redux", "React", "Express", "MongoDB"],
    progress: 100,
    level: "Advanced",
    imgSrc:
      "https://2.bp.blogspot.com/-5Im8TZ77nek/XoUPpfr5wAI/AAAAAAAAB-M/cBUITb0sS_glAw57hGIOBPcWKdNpT-W7gCK4BGAYYCw/s400/Screen%2BShot%2B2020-04-02%2Bat%2B1.02.51%2BAM.png"
  },
  {
    group: "Web",
    projectName: "Roguelike Dungeon Crawler Game",
    description: "Using react, redux to make Roguelike Dungeon Crawler Game",
    tags: ["React", "Redux", "Javascript"],
    progress: 100,
    level: "Advanced",
    imgSrc: "https://i.ibb.co/Qd2672N/Screen-Shot-2020-03-16-at-9-18-37-PM.png"
  },
  {
    group: "Web",
    projectName: "Simon Game",
    description: "Javascript game with jQuery, CSS and HTML",
    tags: ["jQuery", "HTML", "CSS"],
    progress: 100,
    level: "Intermidiate"
  },
  {
    group: "Web",
    projectName: "Tic Tac Toe",
    description: "Tic Tac Toe with jQuery, which has unbeatable AI",
    tags: ["CSS", "HTML", "Javascript"],
    progress: 100,
    level: "Intermidiate",
    imgSrc: "https://i.ibb.co/MGnGMfR/Screen-Shot-2020-03-16-at-9-20-50-PM.png"
  },
  {
    group: "Game",
    projectName: "Royale Quest",
    description:
      "Unity game with 3D models, C# scripting, Partical, sound system and local saving",
    tags: ["Unity", "C#"],
    progress: 100,
    level: "Intermidiate",
    imgSrc:
      "https://1.bp.blogspot.com/-voc0gHNifds/XoUOoKMRrOI/AAAAAAAAB9s/iuyM6IsRG8wSb2zMhjx1w3PuQPHFoOCrQCK4BGAYYCw/s320/Screen%2BShot%2B2020-04-02%2Bat%2B12.58.33%2BAM.png"
  },
  {
    group: "Game",
    projectName: "Wizard War",
    description:
      "Unity game with 3D models, C# scripting, Partical, sound system and local saving",
    tags: ["Unity", "C#"],
    progress: 100,
    level: "Intermidiate",
    imgSrc:
      "https://1.bp.blogspot.com/-paei6MIjdHE/XoUOtZAD_mI/AAAAAAAAB90/7UH92Ex0-N4CyfGrcB2WvOxcAgLiZpcwgCLcBGAsYHQ/s320/Screen%2BShot%2B2020-04-02%2Bat%2B12.58.07%2BAM.png"
  }
];

export default projects;
